import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

const labelVariants = cva('text-sm text-gray-700 block', {
  variants: {
    weight: {
      normal: 'font-normal',
      medium: 'font-medium',
    },
  },
  defaultVariants: {
    weight: 'medium',
  },
})

interface Props extends VariantProps<typeof labelVariants> {
  children: React.ReactNode
  htmlFor?: string
  isRequired?: boolean
}

function Label({ children, htmlFor, weight, isRequired = false }: Props) {
  return (
    <label htmlFor={htmlFor} className={labelVariants({ weight })}>
      {children}
      {isRequired && <span className="text-red-500 ml-1">*</span>}
    </label>
  )
}

export default Label
